import { render } from "./StatsBoxes.vue?vue&type=template&id=2f17a288&scoped=true"
import script from "./StatsBoxes.vue?vue&type=script&lang=js"
export * from "./StatsBoxes.vue?vue&type=script&lang=js"

import "./StatsBoxes.vue?vue&type=style&index=0&id=2f17a288&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f17a288"]])

export default __exports__